module.exports = __webpack_public_path__ + "img/Moderation-icon.f1d6ed31.svg";